import { useMutation, useQueryClient } from '@tanstack/react-query';

type UpdateOrganizationUserParams = {
  id: number;
  organizationId: number;
  is_support?: boolean;
};

export default function useUpdateAdminOrganizationUser() {
  const queryClient = useQueryClient();
  const token = (document.getElementsByName('csrf-token')[0] as HTMLMetaElement | undefined)
    ?.content;

  return useMutation({
    mutationFn: async (params: UpdateOrganizationUserParams) => {
      const { id, organizationId: _organizationId, ...body } = params;
      const response = await fetch(`/admin/api/organization_users/${id}`, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-CSRF-Token': token || '',
        },
        body: JSON.stringify(body),
      });
      if (!response.ok) {
        throw new Error('組織ユーザーの更新に失敗しました');
      }
      return await response.json();
    },
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({
        queryKey: ['admin', 'organization-users', variables.organizationId],
      });
    },
  });
}
